module.exports = __webpack_public_path__ + "img/418.f5d6f247.gif";